<template>
  <InitialAvatarIcon
    data-testid="statement-avatar"
    :class="computedClass"
    :icon="iconName"
    :size="size"
  />
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { InitialAvatarIcon } from '@warrenbrasil/nebraska-web';
import { EDirection } from '@/modules/transaction/services/unified-account/enums';

@Component({
  components: { InitialAvatarIcon }
})
export default class StatementAvatar extends Vue {
  @Prop({ type: String, required: true })
  readonly iconName!: string;

  @Prop({ type: String, required: true })
  readonly type!: EDirection;

  @Prop({ type: String, default: 'extra-small' })
  readonly size!: string;

  get computedClass() {
    return `initial-avatar-icon__${this.type}`;
  }
}
</script>

<style lang="less" scoped>
.initial-avatar-icon {
  &__Credit {
    color: @status-positive;
    background-color: @status-positive-background;
  }
  &__Debit {
    color: @text-primary;
    background-color: @background-tertiary;
  }
  &__Future {
    color: @status-info;
    background-color: @status-info-background;
  }
}
</style>
